import { render } from "./guid-create-new.vue?vue&type=template&id=10fa1199"
import script from "./guid-create-new.vue?vue&type=script&setup=true&lang=js"
export * from "./guid-create-new.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/whatsapp/create-catalog/guid-create-new.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10fa1199"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10fa1199', __exports__)) {
    console.log('reload')
    api.reload('10fa1199', __exports__)
  }
  
  module.hot.accept("./guid-create-new.vue?vue&type=template&id=10fa1199", () => {
    console.log('re-render')
    api.rerender('10fa1199', render)
  })

}


export default __exports__